/**
 * @logic dispatchBoard
 * @status PORTED (from Logis lib/constants/dispatchBoard.ts)
 * Aligned column keys to doc load statuses where practical.
 */

export const BOARD_COLUMNS = [
  { key: "pending", label: "Pending", statuses: ["draft", "pending", "open"] },
  { key: "assigned", label: "Assigned", statuses: ["dispatched", "assigned"] },
  { key: "transit", label: "In Transit", statuses: ["in_transit", "on_route", "at_pickup", "loaded"] },
  { key: "delivery", label: "At Delivery", statuses: ["delivered", "at_delivery"] },
  { key: "done", label: "Completed", statuses: ["invoiced", "closed", "completed", "in_yard"] },
  { key: "closed", label: "Closed", statuses: ["canceled", "cancelled", "refused"] },
] as const;

export const COLUMN_DROP_STATUS: Record<string, string> = {
  pending: "draft",
  assigned: "dispatched",
  transit: "in_transit",
  delivery: "delivered",
  done: "closed",
  closed: "canceled",
};

export function loadStatusKey(load: { driverStatus?: string; status?: string }): string {
  return (load.driverStatus || load.status || "draft").toLowerCase();
}

export function columnForLoad(load: { driverStatus?: string; status?: string }): string {
  const s = loadStatusKey(load);
  const col = BOARD_COLUMNS.find((c) =>
    c.statuses.some((st) => s === st || s === st.replace(/_/g, " "))
  );
  return col?.key ?? "pending";
}

export function loadsForColumn(
  loads: { id: string; driverStatus?: string; status?: string }[],
  columnKey: string
) {
  const col = BOARD_COLUMNS.find((c) => c.key === columnKey);
  if (!col) return [];
  return loads.filter((l) => {
    const s = loadStatusKey(l);
    return col.statuses.some((st) => s === st || s === st.replace(/_/g, " "));
  });
}
